export const THERAPIST_TYPE_OPTIONS = [
    { value: 'SKIN', label: 'Skin' },
    { value: 'LASER', label: 'Laser' },
    { value: 'LHR', label: 'LHR' },
] as const;

export const WAVELENGTH_OPTIONS = [
    { value: '1064/940/808/740', label: '1064/940/808/740' },
    { value: '1064', label: '1064' },
    { value: '1320', label: '1320' },
    { value: '532', label: '532' },
] as const;

export const BODY_PART_OPTIONS = [
    { value: 'UA / Axilla', label: 'UA / Axilla' },
    { value: 'UL', label: 'UL' },
    { value: 'Side locks', label: 'Side locks' },
    { value: 'Chin', label: 'Chin' },
    { value: 'Full Face', label: 'Full Face' },
    { value: 'Half Face', label: 'Half Face' },
    { value: 'Full Hand', label: 'Full Hand' },
    { value: 'Full Leg', label: 'Full Leg' },
    { value: 'Half Leg', label: 'Half Leg' },
    { value: 'Bikini', label: 'Bikini' },
    { value: 'Back', label: 'Back' },
    { value: 'Chest', label: 'Chest' },
    { value: 'Umbilicus', label: 'Umbilicus' },
    { value: 'Full Body', label: 'Full Body' },
    { value: 'Eyebrows', label: 'Eyebrows' },
    { value: 'Ear', label: 'Ear' },
    { value: 'Neck', label: 'Neck' },
] as const;

export const MACHINE_OPTIONS = [
    { value: 'Diode', label: 'Diode' },
] as const;

export const SKIN_TYPE_OPTIONS = [
    { value: 'Type I', label: 'Type I' },
    { value: 'Type II', label: 'Type II' },
    { value: 'Type III', label: 'Type III' },
    { value: 'Type IV', label: 'Type IV' },
    { value: 'Type V', label: 'Type V' },
    { value: 'Type VI', label: 'Type VI' },
] as const;

export const THERAPIST_TYPE_COLORS = {
    SKIN: 'green',
    LASER: 'blue',
    LHR: 'purple',
} as const;

export type TherapistType = keyof typeof THERAPIST_TYPE_COLORS; 